import type { PricelistItemDto } from "../../../../api";
import { AppCard } from "../../../../components/common/card";
import { Text } from "../../../../components/common/typography";
import { CurrencyAmount } from "../../../../components/common/currency_amount";

interface ProductPricingTiersProps {
  tiers?: PricelistItemDto[] | null;
  activeQuantity?: number;
}

export function ProductPricingTiers({
  tiers,
  activeQuantity = 1,
}: ProductPricingTiersProps) {
  if (!tiers || tiers.length === 0) {
    return null;
  }

  const sorted = [...tiers].sort(
    (a, b) => (a.minQuantity ?? 0) - (b.minQuantity ?? 0)
  );

  return (
    <AppCard
      title="Pricelist"
      color="bg-transparent"
      borderColor="border-uiSecondary/40"
      className="w-full bg-transparent"
    >
      <div className="space-y-2">
        <Text variant="body" tone="body">
          Transparent pricing for every order size
        </Text>
        <div className="rounded-xl border border-uiSecondary/60 divide-y divide-uiSecondary/60 bg-transparent">
          {sorted.map((tier, index) => {
            const minQty = tier.minQuantity ?? 1;
            const nextMin =
              sorted[index + 1]?.minQuantity ?? Number.POSITIVE_INFINITY;
            const isActive =
              activeQuantity >= minQty && activeQuantity < nextMin;

            return (
              <div
                key={`${tier.id ?? index}-${tier.minQuantity}`}
                className={`flex items-center justify-between gap-4 px-4 py-3 transition-colors ${
                  isActive ? "bg-primary/10 border-l-2 border-primary" : ""
                }`}
              >
                <div className="flex flex-col">
                  <Text variant="bodyLgBold" tone="dark" className={isActive ? "text-primary" : undefined}>
                    {minQty}+ units
                  </Text>
                  <Text variant="bodyXs" className="flex items-center gap-2">
                    MOQ: {minQty}
                    {isActive && (
                      <Text variant="bodyXs" tone="accent" as="span" inline className="inline-flex items-center rounded-full bg-primary/20 px-2 py-0.5">
                        Current
                      </Text>
                    )}
                  </Text>
                </div>
                <CurrencyAmount
                  amount={tier.fixedPrice ?? 0}
                  currency="QAR"
                  variant="bodyLg"
                  tone="dark"
                />
              </div>
            );
          })}
        </div>
      </div>
    </AppCard>
  );
}
